import DefaultManager from "./Default.manager";
import { language } from "../languageProvider/language/language";
import ListIcon from "../assets/icons/list-icon";

class CraiManager extends DefaultManager {
  signboardId;

  constructor(signboardId) {
    super(signboardId);
    this.signboardId = signboardId;
  }
  
  getAddCartButtonText(defaultLanguage) {
    return language[defaultLanguage].aggiungi_alla_lista_crai;
  }
  
  getProductAddCartButtonText(defaultLanguage) {
    return language[defaultLanguage].aggiungi_crai;
  }

  getCartIcon(params = {}) {
    return <ListIcon {...params} />;
  }
}

export default CraiManager;
